import {
  QuerySortDirection,
  WorkspaceMemberQuerySortBy,
} from '@up2stay/up2promo-api-client';

export type MembersListSortOption =
  | 'joinedDesc'
  | 'joinedAsc'
  | 'nameAsc'
  | 'nameDesc'
  | 'roleAsc'
  | 'statusAsc';

export const MEMBERS_LIST_SORT_OPTIONS: MembersListSortOption[] = [
  'joinedDesc',
  'joinedAsc',
  'nameAsc',
  'nameDesc',
  'roleAsc',
  'statusAsc',
];

export function membersListSortToQuery(sort: MembersListSortOption): {
  sortBy: WorkspaceMemberQuerySortBy;
  sortOrder: QuerySortDirection;
} {
  switch (sort) {
    case 'joinedAsc':
      return {
        sortBy: WorkspaceMemberQuerySortBy.CREATED_AT,
        sortOrder: QuerySortDirection.ASC,
      };
    case 'nameAsc':
      return {
        sortBy: WorkspaceMemberQuerySortBy.NAME,
        sortOrder: QuerySortDirection.ASC,
      };
    case 'nameDesc':
      return {
        sortBy: WorkspaceMemberQuerySortBy.NAME,
        sortOrder: QuerySortDirection.DESC,
      };
    case 'roleAsc':
      return {
        sortBy: WorkspaceMemberQuerySortBy.ROLE,
        sortOrder: QuerySortDirection.ASC,
      };
    case 'statusAsc':
      return {
        sortBy: WorkspaceMemberQuerySortBy.STATUS,
        sortOrder: QuerySortDirection.ASC,
      };
    case 'joinedDesc':
    default:
      return {
        sortBy: WorkspaceMemberQuerySortBy.CREATED_AT,
        sortOrder: QuerySortDirection.DESC,
      };
  }
}
